$(document).on('turbolinks:load ready', function() {
  $('#select-all-rows').on('change', function() {
    $('#items-list :checkbox').prop("checked", this.checked);
  });

  $(document).on('change', '#licensee-select-all-rows', function() {
    $('#licensees-list :checkbox').prop("checked", this.checked);
  });
});
